/**
 * Custom element that renders the icons within as a stack,
 * thus allowing multiple icons to be composed together.
 */
export class MdIconStackCustomElement
{
}
